export default "__VITE_ASSET__DcgrOW5a__"